import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { withDefaults, ref, computed } from "vue";
import { PasswordInputProps } from "@/types";
import { getIcon } from "@/util";
import { useVModel } from "@/hooks";


/**
 * A generic password input.
 */
const __default__ = {
  name: "PasswordInput",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: {},
    label: { default: "Password" },
    errorMessage: { type: [String, Boolean], default: "" }
  },
  emits: ["update:modelValue", "enter"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const showPassword = ref(false);
const model = useVModel(props, "modelValue");

const showError = computed(
  () => (props.errorMessage && props.errorMessage.length > 0) || false
);

/**
 * Toggles the password visibility.
 */
function handleToggle() {
  showPassword.value = !showPassword.value;
}

/**
 * Emits an event when enter is clicked.
 */
function handleKeydown(e?: { key: string }) {
  if (e?.key === "Enter") {
    emit("enter");
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createBlock(_component_q_input, {
    modelValue: _unref(model),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
    filled: "",
    label: props.label,
    type: showPassword.value ? 'text' : 'password',
    "data-cy": "input-password",
    "error-message": props.errorMessage || '',
    error: showError.value,
    onKeydown: handleKeydown
  }, {
    append: _withCtx(() => [
      _createVNode(_component_q_icon, {
        name: showPassword.value ? _unref(getIcon)('pw-show') : _unref(getIcon)('pw-hide'),
        tooltip: "Toggle show password",
        class: "cursor-pointer",
        onClick: handleToggle
      }, null, 8, ["name"])
    ]),
    _: 1
  }, 8, ["modelValue", "label", "type", "error-message", "error"]))
}
}

})